export function getPortalPathForUser(user) {
  if (!user) return '/login/';
  if (user.is_superuser) return '/superuser/dashboard/';
  if (user.is_staff) return '/staff/dashboard/';
  if (user.is_merchant_specialist) return '/superuser/invoices/';
  if (user.is_embed_tester) return '/embed-tester/';
  return '/login/';
}

export function isEmbedTesterUser(user) {
  return Boolean(user?.is_embed_tester);
}

export function canAccessMerchantPay(user) {
  return Boolean(user?.is_superuser || user?.is_merchant_specialist);
}

export function isMerchantSpecialistUser(user) {
  return Boolean(user?.is_merchant_specialist) && !user?.is_superuser && !user?.is_staff;
}
